import Theme from "../../styles/Theme/Theme";

export const getColorByPriority = (priority) => {
    const priorityLevel = priority?.split(" - ")?.[0];

    switch (priorityLevel) {
        case "1":
            return 'critical-base';
        case "2":
            return 'high-base';
        case "3":
            return 'medium-base';
        case "4":
            return 'low-base';
        default:
            return 'info-base';
    };
};